import { View, Text, Image } from "react-native";
import React, { useState, useEffect } from "react";
import { danger, femaleColor, gray, maleColor, primary } from "../../colors";
import MyText from "../custom/MyText";
import { doctorAvatar } from "../../imports";
import detailConsultationUser from "../../api/consultation/detailConsultationUser";
import childConsultationStatus from "../../api/consultation/childConsultationStatus";
import { useNavigation } from "@react-navigation/native";
import MyButton from "../custom/MyButton";
import closeConsultation from "../../api/consultation/closeConsultation";
import translate from "../../functions/translate";
import Fade from "../animation/Fade";
import { Toast } from "react-native-toast-message/lib/src/Toast";

export default function PatientChatDetail({
  gender,
  type,
  children,

  id,
}) {
  const navigation = useNavigation();
  const [patientDetails, setPatientDetails] = useState({ dateBirthHejri: "" });
  const [parentDetails, setParentDetails] = useState({});
  const [showAllInformation, setShowAllInformation] = useState(false);
  const [haveChat, setHaveChat] = useState(true);
  const [chatActive, setChatActive] = useState(true);

  useEffect(() => {
  
    detailConsultationUser(id)
      .then(({ data }) => {
       
        if (data.status === 200) {
          setPatientDetails(data.data.child);
          setParentDetails(data.data.parent);
        }
      })
      .catch((err) => {});
  }, [id]);
  const closeChat = () => {

    closeConsultation(id).then(({ data }) => {
    
      if (data.status === 200) {
        Toast.show({
          type: "success",
          text1: "درخواست بستن مشاوره با موفقیت ثبت شد.",
        });
        navigation.navigate("Consultation");
      } else {
        Toast.show({
          type: "error",
          text1: data.description.fa,
        });
      }
    });
  };

  return haveChat ? (
    <View
      style={{
        width: "92%",
        marginHorizontal: 5,
        borderRadius: 15,
        borderColor: patientDetails.gender === "boy" ? maleColor : femaleColor,
        borderWidth: 1,
        padding: 10,
        backgroundColor: "#F9F9F9",

        alignItems: "center",
      }}
    >
      <View style={{ width: "100%", flexDirection: "row" }}>
        <View>
          <View>
            <MyText style={{ fontSize: 18, fontWeight: "bold" }}>
              {`${patientDetails.name || ""} ${patientDetails.lastName || ""}`}
            </MyText>
          </View>
          <View>
            <MyText style={{ fontSize: 15, marginTop: 5 }}>
              {`${translate("child of")} ${parentDetails.name || ""} ${
                parentDetails.lastName || ""
              }`}
            </MyText>
          </View>
        </View>
        <View style={{ flex: 1 }}></View>
        <View
          style={{
            width: 70,
            height: 70,
            borderWidth: 1,
            borderColor:
              patientDetails.gender === "boy" ? maleColor : femaleColor,
            borderRadius: 100,
            overflow: "hidden",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Image
            source={{ uri: patientDetails.picURL }}
            defaultSource={doctorAvatar}
            style={{ width: 60, height: 60 }}
            resizeMode="contain"
          />
        </View>
      </View>

      <View style={{ width: "96%", flexDirection: "row" }}>
        <Fade isShown={showAllInformation}>
          <View style={{ width: "100%" }}>
            <View style={{ flexDirection: "row", marginVertical: 5 }}>
              <MyText>{translate("birth date")}</MyText>
              <MyText> : </MyText>
              <MyText>
                {patientDetails.dateBirthHejri.replaceAll("-", "/")}
              </MyText>
            </View>
            <View style={{ flexDirection: "row", marginVertical: 5 }}>
              <MyText>{translate("birth weight")}</MyText>
              <MyText> : </MyText>
              <MyText>{`${+patientDetails.fWeight}`}</MyText>
              <MyText> </MyText>
              <MyText>{translate("grams")}</MyText>
            </View>
            <View style={{ flexDirection: "row", marginVertical: 5 }}>
              <MyText>{translate("birth height")}</MyText>
              <MyText> : </MyText>
              <MyText>{`${+patientDetails.fHeight}`}</MyText>
              <MyText> </MyText>
              <MyText>{translate("cm")}</MyText>
            </View>
            <View style={{ flexDirection: "row", marginVertical: 5 }}>
              <MyText>{translate("pregnancy due date")}</MyText>
              <MyText> : </MyText>
              <MyText>{`${+patientDetails.pregnancyWeek}`}</MyText>
              <MyText> </MyText>
              <MyText>{translate("week")}</MyText>
            </View>
          </View>
        </Fade>
        {/* <MyButton
          text={"بستن مشاوره"}
          style={{ backgroundColor: danger }}
          textStyle={{ fontSize: 13 }}
          onPress={closeChat}
        /> */}
      </View>
      <View
        style={{
          flexDirection: "row",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        {type !== "closed" && (
          <MyButton
            text={"بستن مشاوره"}
            style={{
              backgroundColor: danger,
              marginTop: 15,
              justifyContent: "center",
              alignItems: "center",
            }}
            textStyle={{ fontSize: 11 }}
            onPress={closeChat}
          />
        )}
        
        <MyButton
          textStyle={{ fontSize: 14 }}
          style={{
            marginTop: 15,
            justifyContent: "center",
            alignItems: "center",
          }}
          onPress={() => setShowAllInformation(!showAllInformation)}
          text={!showAllInformation ? "مشخصات" : translate("close")}
        />
        <MyButton
          textStyle={{ fontSize: 14 }}
          style={{
            marginTop: 15,
            justifyContent: "center",
            alignItems: "center",
          }}
          onPress={() =>
            navigation.navigate("TestNavigator", {
              screen: "PatientTests",
              initial: false,
              params: {
                chatId: id,
                childId: patientDetails.id,
                backToChat : true,
              },
            })
          }
          text={translate("tests")}
        />
      </View>
    </View>
  ) : (
    <View
      style={{
        width: "92%",
        marginHorizontal: 5,
        borderRadius: 15,
        borderColor: patientDetails.gender === "boy" ? maleColor : femaleColor,
        borderWidth: 1,
        padding: 10,
        backgroundColor: "#F9F9F9",
        marginTop: -10,
        flexDirection: "row",
        alignItems: "center",
      }}
    ></View>
  );
}
